import styled from "styled-components";

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.brand.ink};
`;

export const Initials = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => props.theme.brand.navy};
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.4px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Name = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.brand.ink};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Company = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.brand.muted};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
